import { __awaiter, __generator, __read, __values } from "tslib";
import { getKeyByPath, isKey } from '@tencent/memoire-core';
import { IntervalMath } from '../algorithm/interval';
import { createContext } from './query-job';
import { DatabaseInternalError } from '../../error';
var QueryJobFilter = /** @class */ (function () {
    function QueryJobFilter(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    QueryJobFilter.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, current, filterGroups, filter, _a, _b, pointers;
            var e_1, _c;
            return __generator(this, function (_d) {
                filters = [];
                current = this.node;
                filterGroups = [filters];
                // iterate the filter linked list and transform the list into filter groups
                while (current) {
                    // create a new group when occurs regroup flag
                    if (current.regroup) {
                        filters = [];
                        filterGroups.push(filters);
                    }
                    filters.push(this.createFilter(current));
                    current = current.nextFilter;
                }
                filter = function (_a) {
                    var _b = __read(_a, 2), datum = _b[1];
                    return filterGroups.some(function (filters) { return filters.every(function (filter) { return filter(datum); }); });
                };
                try {
                    for (_a = __values(this.context.inputs), _b = _a.next(); !_b.done; _b = _a.next()) {
                        pointers = _b.value;
                        output.push(pointers.filter(filter));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Transform a filter node into a filter function
     *
     * @param node the filter node
     * @returns a filter function to determine whether the data should be kept.
     *
     * The filter function will return true only if
     * at least one interval contains the key of data
     */
    QueryJobFilter.prototype.createFilter = function (node) {
        var imath = new IntervalMath(node.comparer);
        return function (data) {
            return node.intervals.some(function (interval) {
                if (data === undefined) {
                    throw new DatabaseInternalError('can not do filter on non-hydrated data');
                }
                var item = getKeyByPath(data, node.path);
                return isKey(item) && imath.contains(interval, item);
            });
        };
    };
    return QueryJobFilter;
}());
export { QueryJobFilter };
export default QueryJobFilter;
//# sourceMappingURL=query-job-filter.js.map